var _rect, _path, _path2, _circle, _path3, _circle2, _path4, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 16,
    fill: "#EAF3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 18L25 18L25 23",
    stroke: "#6CA5D4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43L25 51L38 51",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 46.0323,
    r: 5.03226,
    fill: "#EAF3FA",
    stroke: "#413D45",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6511 57.8805C41.0858 54.1126 44.7318 51.4382 49 51.4382C53.2682 51.4382 56.9142 54.1126 58.3489 57.8805C58.5946 58.5257 58.4415 59.1163 58.019 59.5897C57.5761 60.0858 56.8357 60.4382 56 60.4382H42C41.1643 60.4382 40.4239 60.0858 39.981 59.5897C39.5585 59.1163 39.4054 58.5257 39.6511 57.8805Z",
    fill: "#C7DFF2",
    stroke: "#413D45",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 15.0323,
    r: 5.03226,
    fill: "#EAF3FA",
    stroke: "#413D45",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6511 26.8805C41.0858 23.1126 44.7318 20.4382 49 20.4382C53.2682 20.4382 56.9142 23.1126 58.3489 26.8805C58.5946 27.5257 58.4415 28.1163 58.019 28.5897C57.5761 29.0858 56.8357 29.4382 56 29.4382H42C41.1643 29.4382 40.4239 29.0858 39.981 28.5897C39.5585 28.1163 39.4054 27.5257 39.6511 26.8805Z",
    fill: "#C7DFF2",
    stroke: "#413D45",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 30.5,
    r: 3.5,
    fill: "#EAF3FA",
    stroke: "#413D45",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 41.5,
    r: 3.5,
    fill: "#EAF3FA",
    stroke: "#413D45",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 41.5,
    r: 3.5,
    fill: "#413D45",
    stroke: "#413D45",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 30.5,
    r: 3.5,
    fill: "#6CA5D4",
    stroke: "#413D45",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.3f1f4026d097197ff6349e98d29ec455.svg";
export { ForwardRef as ReactComponent };